var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isOrgAdmin ? _c('div', [_c('error-dialog', {
    attrs: {
      "status": _vm.toggleStatus
    }
  }), _c('v-menu', {
    attrs: {
      "top": !_vm.bottom,
      "bottom": _vm.bottom,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": !_vm.fab,
            "fab": _vm.fab,
            "small": _vm.small,
            "disabled": _vm.disabled || [_vm.blankDesignId, _vm.nullCoverDesignId].includes(_vm.targetId)
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiCog)
          }
        })], 1)];
      }
    }], null, false, 3256394835),
    model: {
      value: _vm.isOpen,
      callback: function ($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "width": "280"
    }
  }, [_c('div', {
    staticClass: "overline short mt-n1 mb-n2"
  }, [_vm._v("Organization tools")]), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "readonly": "",
      "label": "Include this design in your organization's private catalog",
      "disabled": _vm.loadStatus.pending || _vm.toggleStatus.pending,
      "input-value": _vm.hasOrgTag
    },
    on: {
      "click": _vm.toggle
    }
  }), _c('div', {
    staticClass: "text--label-active mt-4"
  }, [_vm._v("Your changes may take up to 15 minutes to take effect")])], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }